import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { EntitydefsService } from '@savvy/entity-definition';
import { ReminderDefService, ReminderDefsService, RemindersCompService, ReminderService, RemindersService } from '@savvy/reminders';
import { EditorModule } from '../editor/editor.module';
import { FloMaterialModule } from '../flo.material.module';
import { SharedModule } from '../shared/shared.module';
import { TimeSelectModule } from '../time-select/time-select.module';
import { SenderidValidator } from '../validators/senderid.validator';
import { AddEditReminderDefComponent } from './addEditReminderDef.component';
import { AddEditReminderDefPageComponent } from './addEditReminderDefPage.component';
import { ReminderDefsComponent } from './reminderDefs.component';
import { reminderRoutes } from './reminders.routing';
import { RemindersTodayComponent } from './remindersToday.component';
import { ShowReminderComponent } from './showReminder.component';
import { SmsEmailMessagePopupComponent } from './sms-email-message-popup/sms-email-message-popup.component';

@NgModule({
  imports: [
    CommonModule,
    EditorModule,
    RouterModule.forChild(reminderRoutes),
    FloMaterialModule,
    SharedModule,
    TimeSelectModule,
    TranslateModule
  ],
  declarations: [
    AddEditReminderDefComponent,
    AddEditReminderDefPageComponent,
    ReminderDefsComponent,
    RemindersTodayComponent,
    ShowReminderComponent,
    SmsEmailMessagePopupComponent,
    SenderidValidator

  ],
  exports: [
    ShowReminderComponent,
    AddEditReminderDefPageComponent,
    RemindersTodayComponent
  ],
  providers: [
    ReminderService,
    RemindersService,
    ReminderDefService,
    RemindersCompService,
    ReminderDefsService,
    EntitydefsService
  ]
})

export class AppRemindersModule { }
